// Translation map for aspire.constants.feedbackAriaLabel and related aria labels


export function feedbackAriaLabel(intl) {
  return {
    empty: {
      title_text: intl.formatMessage({
        id: 'aspire.feedbackAriaLabel.empty.titleText',
        defaultMessage: 'You have not written this section!',
      }),
      title: intl.formatMessage({
        id: 'aspire.feedbackAriaLabel.empty.titleText',
        defaultMessage: 'You have not written this section!',
      }),
      body: {
        categories: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.empty.body.categories',
          defaultMessage: ' Unable to find any mentioned categories as the seciton is empty.',
        }),
        language: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.empty.body.language',
          defaultMessage: ' The language parameter is evaluated along the following aspects. Write atleast <b>50+</b> words for language feedback.',
        }),
        impact: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.empty.body.impact',
          defaultMessage: ' The impact parameter is evaluated along the following aspects.',
        }),
        skills: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.empty.body.skills',
          defaultMessage: ' There are no skills detected as the section is empty.',
        }),
        seo: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.empty.body.seo',
          defaultMessage: ' There are no relevant SEO keywords detected as the section is empty.',
        }),
        section_score: {
          Headline: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.empty.body.sectionScore.headline',
            defaultMessage: 'Start writing in the edit mode.',
          }),
          Summary: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.empty.body.sectionScore.summary',
            defaultMessage: 'Start writing in the edit mode.',
          }),
          Experience: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.empty.body.sectionScore.experience',
            defaultMessage: 'Start writing in the edit mode.',
          }),
          Education: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.empty.body.sectionScore.education',
            defaultMessage: 'Start writing in the edit mode.',
          }),
        },
      },
    },
    red: {
      title_text: intl.formatMessage({
        id: 'aspire.feedbackAriaLabel.red.titleText',
        defaultMessage: 'Needs Work!',
      }),
      title: intl.formatMessage({
        id: 'aspire.feedbackAriaLabel.red.titleText',
        defaultMessage: 'Needs Work!',
      }),
      body: {
        categories: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.red.body.categories',
          defaultMessage: ' Please consider adding more relevant categories in this section. See edit mode for category suggestions.',
        }),
        language: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.red.body.language',
          defaultMessage: ' Follow the feedback to improve your language in this section.',
        }),
        impact: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.red.body.impact',
          defaultMessage: ' Follow the feedback to make your section more impactful.',
        }),
        skills: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.red.body.skills',
          defaultMessage: ' You should try to include more skills relevant to target job function(s) from your profile.',
        }),
        seo: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.red.body.seo',
          defaultMessage: ' Include more SEO keywords by incorporating additional information categories. See edit mode for suggestions.',
        }),
        section_score: {
          Headline: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.red.body.sectionScore.headline',
            defaultMessage: 'Consider the feedback to improve this section',
          }),
          Summary: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.red.body.sectionScore.summary',
            defaultMessage: 'Consider the feedback to improve this section',
          }),
          Experience: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.red.body.sectionScore.experience',
            defaultMessage: 'Consider the feedback to improve this section',
          }),
          Education: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.red.body.sectionScore.education',
            defaultMessage: 'Consider the feedback to improve this section',
          }),
        },
      },
    },
    yellow: {
      title_text: intl.formatMessage({
        id: 'aspire.feedbackAriaLabel.yellow.titleText',
        defaultMessage: 'On Track!',
      }),
      title: intl.formatMessage({
        id: 'aspire.feedbackAriaLabel.yellow.titleText',
        defaultMessage: 'On Track!',
      }),
      body: {
        categories: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.yellow.body.categories',
          defaultMessage: ' Please consider adding more relevant categories in this section. See edit mode for category suggestions.',
        }),
        language: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.yellow.body.language',
          defaultMessage: ' Follow the feedback to improve your language in this section.',
        }),
        impact: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.yellow.body.impact',
          defaultMessage: ' Follow the feedback to make your section more impactful.',
        }),
        skills: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.yellow.body.skills',
          defaultMessage: ' You should try to include more skills relevant to target job function(s) from your profile.',
        }),
        seo: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.yellow.body.seo',
          defaultMessage: ' Include more SEO keywords by incorporating additional information categories. See edit mode for suggestions.',
        }),
        section_score: {
          Headline: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.yellow.body.sectionScore.headline',
            defaultMessage: 'Consider the feedback to improve this section',
          }),
          Summary: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.yellow.body.sectionScore.summary',
            defaultMessage: 'Consider the feedback to improve this section',
          }),
          Experience: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.yellow.body.sectionScore.experience',
            defaultMessage: 'Consider the feedback to improve this section',
          }),
          Education: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.yellow.body.sectionScore.education',
            defaultMessage: 'Consider the feedback to improve this section',
          }),
        },
      },
    },
    green: {
      title_text: intl.formatMessage({
        id: 'aspire.feedbackAriaLabel.green.titleText',
        defaultMessage: 'Good Job!',
      }),
      title: intl.formatMessage({
        id: 'aspire.feedbackAriaLabel.green.titleText',
        defaultMessage: 'Good Job!',
      }),
      body: {
        categories: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.green.body.categories',
          defaultMessage: ' You have added sufficient number of relevant categories.',
        }),
        language: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.green.body.language',
          defaultMessage: ' Follow the feedback to further improve your language in this section',
        }),
        impact: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.green.body.impact',
          defaultMessage: ' Your section is impactful. Great work!',
        }),
        skills: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.green.body.skills',
          defaultMessage: ' You have included top skills relevant to target job function(s) from your profile.',
        }),
        seo: intl.formatMessage({
          id: 'aspire.feedbackAriaLabel.green.body.seo',
          defaultMessage: ' You have done a good job of including SEO keywords here.',
        }),
        section_score: {
          Headline: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.green.body.sectionScore.headline',
            defaultMessage: 'You have done a good job with this section',
          }),
          Summary: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.green.body.sectionScore.summary',
            defaultMessage: 'You have done a good job with this section',
          }),
          Experience: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.green.body.sectionScore.experience',
            defaultMessage: 'You have done a good job with this experience',
          }),
          Education: intl.formatMessage({
            id: 'aspire.feedbackAriaLabel.green.body.sectionScore.education',
            defaultMessage: 'You have done a good job with this section',
          }),
        },
      },
    },
  }
}

export function editScreenAriaLabel(intl) {
  return {
    logButtonActive: intl.formatMessage({
      id: 'aspire.editScreenAriaLabel.logButtonActive',
      defaultMessage: 'Click this button to see the history of previous edited versions of the section',
    }),
    logButtonInactive: intl.formatMessage({
      id: 'aspire.editScreenAriaLabel.logButtonInactive',
      defaultMessage: 'See the history of previous edited versions of the section. You have no edits yet.',
    }),
    editButton: intl.formatMessage({
      id: 'aspire.editScreenAriaLabel.editButton',
      defaultMessage: 'Click on this button to try the edit mode to instantly see the effect any changes have on your score',
    }),
    previousButton: intl.formatMessage({
      id: 'aspire.editScreenAriaLabel.previousButton',
      defaultMessage: 'Click to see the previous entry of this section',
    }),
    nextButton: intl.formatMessage({
      id: 'aspire.editScreenAriaLabel.nextButton',
      defaultMessage: 'Click to see the feedback of next entry in this section',
    }),
  }
}


export function contentSectionAriaLabel(intl) {
  return {
    impact: {
      Summary: {
        red: {
          action_oriented: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.summary.red.actionOriented',
            defaultMessage:
              'You have not begun your bullets with an action verb. Try using action oriented verbs in the beginning to create more impact.',
          }),
          specifics: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.summary.red.specifics',
            defaultMessage:
              'Try to use specifics in the bullets to quantify your contribution to the company and create a greater impact on the profile visitor.',
          }),
        },
        green: {
          action_oriented: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.summary.green.actionOriented',
            defaultMessage:
              'Good Job! You have begun your bullets with strong action verbs signalling actions performed by you.',
          }),
          specifics: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.summary.green.specifics',
            defaultMessage:
              'You have done a good job of quantifying your impact in the bullets.',
          }),
        },
        yellow: {
          action_oriented: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.summary.yellow.actionOriented',
            defaultMessage:
              'You have not begun your bullets with an action verb. Try using action oriented verbs in the beginning to create more impact.',
          }),
          specifics: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.summary.yellow.specifics',
            defaultMessage:
              'Try to use specifics in the bullets to quantify your contribution to the company and create a greater impact on the profile visitor.',
          }),
        },
      },
      Experience: {
        red: {
          action_oriented: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.experience.red.actionOriented',
            defaultMessage:
              'You have not begun your sentences with an action verb. Try using action oriented verbs in the beginning to create more impact.',
          }),
          specifics: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.experience.red.specifics',
            defaultMessage:
              'Try to use specifics to quantify your contribution to the company and create a greater impact on the profile visitor.',
          }),
        },
        green: {
          action_oriented: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.experience.green.actionOriented',
            defaultMessage:
              'Good Job! You have begun your sentences with strong action verbs signalling actions performed by you.',
          }),
          specifics: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.experience.green.specifics',
            defaultMessage:
              'You have done a good job of quantifying your impact in this experience.',
          }),
        },
        yellow: {
          action_oriented: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.experience.yellow.actionOriented',
            defaultMessage:
              'You have not begun your sentences with an action verb. Try using action oriented verbs in the beginning to create more impact.',
          }),
          specifics: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.impact.experience.yellow.specifics',
            defaultMessage:
              'Try to use specifics to quantify your contribution to the company and create a greater impact on the profile visitor.',
          }),
        },
      },
    },
    language: {
      Headline: {
        red: {
          buzzwords: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.headline.red.buzzwords',
            defaultMessage:
              'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
          verb_overusage: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.headline.red.verbOverusage',
            defaultMessage:
              'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
          tense: '',
          narrative_voice: '',
          spell_check: '',
        },
        green: {
          buzzwords: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.headline.green.buzzwords',
            defaultMessage:
              "Good Job! You have stayed away from using any fillers, that's great!",
          }),
          verb_overusage: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.headline.green.verbOverusage',
            defaultMessage: 'You have not overused any verb, good job!',
          }),
          tense: '',
          narrative_voice: '',
          spell_check: '',
        },
        yellow: {
          buzzwords: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.headline.yellow.buzzwords',
            defaultMessage:
              'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
          verb_overusage: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.headline.yellow.verbOverusage',
            defaultMessage:
              'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
          tense: '',
          narrative_voice: '',
          spell_check: '',
        },
      },
      Summary: {
        red: {
          buzzwords: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.red.buzzwords',
            defaultMessage:
              'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
          verb_overusage: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.red.verbOverusage',
            defaultMessage:
              'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
          tense: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.red.tense',
            defaultMessage:
              'You have switched tenses in your sample multiple times, making it inconsistent. Try writing the sample without switching the tense too much.',
          }),
          narrative_voice: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.red.narrativeVoice',
            defaultMessage:
              'While writing your summary, try to avoid switching voice from first person to third person or vice versa when talking about yourself.',
          }),
          spell_check: '',
        },
        green: {
          buzzwords: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.green.buzzwords',
            defaultMessage:
              "Good Job! You have stayed away from using any fillers, that's great!",
          }),
          verb_overusage: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.green.verbOverusage',
            defaultMessage: 'You have not overused any verb, good job!',
          }),
          tense: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.green.tense',
            defaultMessage:
              'Good Job! You have avoided switching between tenses too much and maintained consistency in your sample.',
          }),
          narrative_voice: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.green.narrativeVoice',
            defaultMessage:
              'You have done a good job of writing your summary section without switching voice from first person to third person or vice versa.',
          }),
          spell_check: '',
        },
        yellow: {
          buzzwords: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.yellow.buzzwords',
            defaultMessage:
              'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
          verb_overusage: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.yellow.verbOverusage',
            defaultMessage:
              'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
          tense: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.yellow.tense',
            defaultMessage:
              'You have switched tenses multiple times in your sample, making it inconsistent. Try writing the sample without switching the tense too much.',
          }),
          narrative_voice: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.summary.yellow.narrativeVoice',
            defaultMessage:
              'While writing your summary, try to avoid switching voice from first person to third person or vice versa when talking about yourself.',
          }),
          spell_check: '',
        },
      },
      Experience: {
        red: {
          buzzwords: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.red.buzzwords',
            defaultMessage:
              'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
          verb_overusage: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.red.verbOverusage',
            defaultMessage:
              'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
          tense: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.red.tense',
            defaultMessage:
              'You have switched tenses in your sample, making it inconsistent. Try writing the sample in single tense.',
          }),
          narrative_voice: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.red.narrativeVoice',
            defaultMessage:
              'You have used third person voice in your sample. Try to write information about yourself in first person.',
          }),
          spell_check: '',
        },
        green: {
          buzzwords: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.green.buzzwords',
            defaultMessage:
              "Good Job! You have stayed away from using any fillers, that's great!",
          }),
          verb_overusage: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.green.verbOverusage',
            defaultMessage: 'You have not overused any verb, good job!',
          }),
          tense: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.green.tense',
            defaultMessage:
              'Good Job! You have avoided switching between tenses and maintained consistency in your sample.',
          }),
          narrative_voice: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.green.narrativeVoice',
            defaultMessage:
              'You have done an excellent job of writing your section in first person and keeping the use of third person voice limited to only necessary parts.',
          }),
          spell_check: '',
        },
        yellow: {
          buzzwords: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.yellow.buzzwords',
            defaultMessage:
              'You have used some filler words. Revise your sentences to make them more effective and concise.',
          }),
          verb_overusage: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.yellow.verbOverusage',
            defaultMessage:
              'You have overused a few verbs. Revise your sentences or use synonyms in their place to make them more effective.',
          }),
          tense: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.yellow.tense',
            defaultMessage:
              'You have switched tenses in your sample, making it inconsistent. Try writing the sample in single tense.',
          }),
          narrative_voice: intl.formatMessage({
            id: 'aspire.contentSectionAriaLabel.language.experience.yellow.narrativeVoice',
            defaultMessage:
              'You have used third person voice in your sample. Try to write information about yourself in first person.',
          }),
          spell_check: '',
        },
      },
    },
    presentation: {
      Summary: {
        red: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Summary.red.bullet_length",
            defaultMessage: "Length needs tuning. Edit your summary and write in about 1600-2200 characters to stay within the sweet spot for readability."
          },
          bullets_count: {
            id: "aspire.contentSectionAriaLabel.presentation.Summary.red.bullets_count",
            defaultMessage: "Structure needs work. Replace dense text with three to four short paragraphs, two to three sentences each, centered on outcomes."
          },
          grammar: {
            id: "aspire.contentSectionAriaLabel.presentation.Summary.red.grammar",
            defaultMessage: "Grammar needs attention. Fix agreement and tense issues, plus spelling errors, to improve clarity and credibility."
          }
        },
        green: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Summary.green.bullet_length",
            defaultMessage: "Spot on length! easy to scan and impactful. Keep this range to maximize recruiter attention and engagement."
          },
          bullets_count: {
            id: "aspire.contentSectionAriaLabel.presentation.Summary.green.bullets_count",
            defaultMessage: "Great structure. Short paragraphs flow well, weaving story, highlighting impact, metrics, and specialties."
          },
          grammar: {
            id: "aspire.contentSectionAriaLabel.presentation.Summary.green.grammar",
            defaultMessage: "Reads smoothly. Tense, agreement, and capitalization are consistent. First-person voice feels natural and confident throughout the section."
          }
        },
        yellow: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Summary.yellow.bullet_length",
            defaultMessage: "Almost there on length. Write in about 1600-2200 characters to stay within the sweet spot for readability."
          },
          bullets_count: {
            id: "aspire.contentSectionAriaLabel.presentation.Summary.yellow.bullets_count",
            defaultMessage: "Close on structure. Aim for three to four short paragraphs. Split long sentences and strengthen topic sentences for clarity."
          },
          grammar: {
            id: "aspire.contentSectionAriaLabel.presentation.Summary.yellow.grammar",
            defaultMessage: "Some slips present. Tidy punctuation and tense shifts, and keep first-person voice consistent across sentences."
          }
        }
      },
      Experience: {
        red: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Experience.red.bullet_length",
            defaultMessage: "Length needs revision. Use 800-1500 characters to stay within the sweet spot for readability. Focus on actions, scope, and quantified results."
          },
          bullets_count: {
            id: "aspire.contentSectionAriaLabel.presentation.Experience.red.bullets_count",
            defaultMessage: "Structure needs overhaul. Convert paragraphs into three to six concise bullets and lead each line with outcome-focused action verbs."
          },
          grammar: {
            id: "aspire.contentSectionAriaLabel.presentation.Experience.red.grammar",
            defaultMessage: "Grammar needs improvement. Tense mix, agreement errors, and spelling issues make bullets hard to trust."
          }
        },
        green: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Experience.green.bullet_length",
            defaultMessage: "Great length. Enough context and measurable outcomes without fluff. Each bullet adds clear value and evidence."
          },
          bullets_count: {
            id: "aspire.contentSectionAriaLabel.presentation.Experience.green.bullets_count",
            defaultMessage: "Clear structure. Three to six crisp bullets with strong verbs first and visible results at the end."
          },
          grammar: {
            id: "aspire.contentSectionAriaLabel.presentation.Experience.green.grammar",
            defaultMessage: "Grammar looks solid. Parallel bullet style, consistent tense, and neat punctuation throughout this role description overall."
          }
        },
        yellow: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Experience.yellow.bullet_length",
            defaultMessage: "Almost there on length. Keep within 800-1500 characters, so results and scope stand out quickly."
          },
          bullets_count: {
            id: "aspire.contentSectionAriaLabel.presentation.Experience.yellow.bullets_count",
            defaultMessage: "Close on structure. Split dense text into three to six crisp bullets, and surface outcomes for better scanning."
          },
          grammar: {
            id: "aspire.contentSectionAriaLabel.presentation.Experience.yellow.grammar",
            defaultMessage: "Some issues appear. Align verb forms, fix commas, and remove typos to improve clarity and professionalism."
          }
        }
      },
      Headline: {
        red: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Headline.red.bullet_length",
            defaultMessage: "Too short! Needs tuning. Use 140-220 characters to stay within the sweet spot for readability."
          },
        },
        green: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Headline.green.bullet_length",
            defaultMessage: "Spot on length. Clear role and value with the right keywords."
          },
        },
        yellow: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Headline.yellow.bullet_length",
            defaultMessage: "Almost there. Add a little detail to sharpen focus. Use 140-220 characters to stay within the sweet spot for readability."
          },
        }
      },
      Education: {
        red: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Education.red.bullet_length",
            defaultMessage: "Length needs refinement. Stay within 300-600 characters for optimal readability. Keep essentials only and remove extraneous detail here."
          },
          bullets_count: {
            id: "aspire.contentSectionAriaLabel.presentation.Education.red.bullets_count",
            defaultMessage: "Structure needs attention. Avoid dense text. Present key items in one to three short bullets with tight phrasing."
          },
        },
        green: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Education.green.bullet_length",
            defaultMessage: "Good length. Degree, focus, honors, and one highlight are clear without unnecessary detail or repetition overall."
          },
          bullets_count: {
            id: "aspire.contentSectionAriaLabel.presentation.Education.green.bullets_count",
            defaultMessage: "Structure works well. Short lines or a few bullets highlight honors, projects, and leadership cleanly throughout."
          },
        },
        yellow: {
          bullet_length: {
            id: "aspire.contentSectionAriaLabel.presentation.Education.yellow.bullet_length",
            defaultMessage: "Almost there. Use 300-600 characters, so essentials remain scannable and relevant to your target roles."
          },
          bullets_count: {
            id: "aspire.contentSectionAriaLabel.presentation.Education.yellow.bullets_count",
            defaultMessage: "Close on structure. Simplify phrasing or convert a paragraph into brief one to three bullets for quick scanning overall."
          },
        }
      }
    }
  }
}

export function personalInformationFeedbackAriaLabel(intl, isResumeCalledCv = false) {
  return {
    red: intl.formatMessage({
      id: 'aspire.personalInformationFeedbackAriaLabel.red',
      defaultMessage:
        'It is very important to get your basic information right. Make sure that you choose a professional profile URL and avoid any errors! and your profile Needs Work!. Consider the feedback to improve this section.',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.personalInformationFeedbackAriaLabel.yellow',
      defaultMessage:
        'It is very important to get your basic information right. Make sure that you choose a professional profile URL and avoid any errors! and your profile is On Track!. Consider the feedback to improve this section.',
    }),
    green: intl.formatMessage({
      id: 'aspire.personalInformationFeedbackAriaLabel.green',
      defaultMessage:
        'It is very important to get your basic information right. Make sure that you choose a professional profile URL and avoid any errors! and your profile Looks Good!. You have done a good job with this section.',
    }),
    feedbackMap: {
      name: {
        green: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.name.green',
          defaultMessage:
            'You have written your profile name in the correct format.',
        }),
        yellow: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.name.yellow',
          defaultMessage:
            'Please mention both your first and last names and ensure that they match the name on your {resumeType, select, cv {CV} other {resume}}.',
        }, { resumeType: isResumeCalledCv ? 'cv' : 'resume' }),
        red: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.name.red',
          defaultMessage:
            'Please mention both your first name and surname on your profile and ensure that it matches the name on your {resumeType, select, cv {CV} other {resume}}.',
        }, { resumeType: isResumeCalledCv ? 'cv' : 'resume' }),
      },
      url: {
        green: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.url.green',
          defaultMessage:
            'You have done a good job of writing a professional profile URL.',
        }),
        yellow: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.url.yellow',
          defaultMessage:
            'Please check the edit mode to make further improvements to your LinkedIn URL and increase your profile visibility.',
        }),
        red: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.url.red',
          defaultMessage:
            'Please check the edit mode to make improvements to your LinkedIn URL and increase your profile visibility.',
        }),
      },
      nyu_stern_url: {
        green: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.nyuSternUrl.green',
          defaultMessage:
            'You have done a good job of writing a professional profile URL.',
        }),
        yellow: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.nyuSternUrl.yellow',
          defaultMessage:
            'Your profile URL can be further optimized for ease of look-up on the web. Please check the edit mode for suggestions.',
        }),
        red: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.nyuSternUrl.red',
          defaultMessage:
            'Your profile URL is not optimized to look for on the web. Please check the edit mode for suggestions.',
        }),
      },
      connections: {
        green: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.connections.green',
          defaultMessage:
            'You have done a good job of forging an extensive professional network!',
        }),
        yellow: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.connections.yellow',
          defaultMessage:
            'You have few connections. Consider expanding your network to more than 500 connections.',
        }),
        red: intl.formatMessage({
          id: 'aspire.personalInformationFeedbackAriaLabel.feedbackMap.connections.red',
          defaultMessage:
            'You have few connections. Consider expanding your network to more than 500 connections.',
        }),
      },
    },
  }
}

export function profilePictureFeedbackAriaLabel(intl) {
  return {
    empty: {
      title_text: intl.formatMessage({
        id: 'aspire.profilePictureFeedbackAriaLabel.empty.titleText',
        defaultMessage: 'You have not uploaded your profile picture!',
      }),
      body: intl.formatMessage({
        id: 'aspire.profilePictureFeedbackAriaLabel.empty.body',
        defaultMessage:
          'Upload your profile picture in the edit mode to get instant feedback',
      }),
    },
    red: {
      title_text: intl.formatMessage({
        id: 'aspire.profilePictureFeedbackAriaLabel.red.titleText',
        defaultMessage: 'Needs Work!',
      }),
      body: intl.formatMessage({
        id: 'aspire.profilePictureFeedbackAriaLabel.red.body',
        defaultMessage: 'Consider the feedback to improve this section',
      }),
    },
    yellow: {
      title_text: intl.formatMessage({
        id: 'aspire.profilePictureFeedbackAriaLabel.yellow.titleText',
        defaultMessage: 'On Track!',
      }),
      body: intl.formatMessage({
        id: 'aspire.profilePictureFeedbackAriaLabel.yellow.body',
        defaultMessage: 'Consider the feedback to improve this section',
      }),
    },
    green: {
      title_text: intl.formatMessage({
        id: 'aspire.profilePictureFeedbackAriaLabel.green.titleText',
        defaultMessage: 'Good Job!',
      }),
      body: intl.formatMessage({
        id: 'aspire.profilePictureFeedbackAriaLabel.green.body',
        defaultMessage:
          'You have done a good job of uploading a professional profile picture',
      }),
    },
  }
}


export function editModalAriaLabel(intl, isResumeCalledCv = false) {
  return {
    loading_sample: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.loadingSample',
      defaultMessage: 'please wait while we load the samples for you',
    }),
    loading_sample_error: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.loadingSampleError',
      defaultMessage: 'Error while laoding samples',
    }),
    next_sample: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.nextSample',
      defaultMessage: 'click to get the next sample. Shift tab to see',
    }),
    previous_sample: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.previousSample',
      defaultMessage: 'Click to get the previous sample. Shift tab to see',
    }),
    saving: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.saving',
      defaultMessage: 'Please wait while your changes are being processed, saving',
    }),
    save: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.save',
      defaultMessage: 'Click to save the changes you have made and get feedback here itself, Save Changes',
    }),
    apply: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.apply',
      defaultMessage: 'Click to apply the changes you have made and get feedback here itself, Apply',
    }),
    close: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.close',
      defaultMessage: 'Click to close the edit modal',
    }),
    reset: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.reset',
      defaultMessage: 'Click to reset changes',
    }),
    no_change_made: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.noChangeMade',
      defaultMessage: 'Button disabled, no changes made',
    }),
    loading_feedback: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.loadingFeedback',
      defaultMessage: 'Please wait while the feedback is loading, Apply',
    }),
    samples: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.samples',
      defaultMessage: 'Click to get the feedback of samples',
    }),
    content: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.content',
      defaultMessage: 'Click to get the feedback of content',
    }),
    skills: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.skills',
      defaultMessage: 'Click to get the feedback of skills',
    }),
    language: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.language',
      defaultMessage: 'Click to get the feedback of language',
    }),
    impact: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.impact',
      defaultMessage: 'Click to get the feedback of impact',
    }),
    rephrase_words: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.rephraseWords',
      defaultMessage: 'Click to get the feedback of rephrase_words',
    }),
    similar_skill: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.similarSkill',
      defaultMessage: 'Similar users are writing about these skills',
    }),
    no_skill: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.noSkill',
      defaultMessage: 'You have not mentioned skills effectively. Please refer to the following guidance for specialised tips on how to highlight skills in this section.',
    }),
    write_skill: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.writeSkill',
      defaultMessage: 'How to write about skills?',
    }),
    write_skill_ans: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.writeSkillAns',
      defaultMessage: 'Writing about skills can be done in two ways, they can be stated directly or as phrases from which the reader can derive skills. For higher visibility, try using direct forms of skills so that recruiters can easily find you.',
    }),
    what_skill: intl.formatMessage({
      id: 'aspire.editModalAriaLabel.whatSkill',
      defaultMessage: 'what skill to write about?',
    }),
    profile_picture: {
      empty: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.profilePicture.empty',
        defaultMessage: 'You have not uploaded your profile picture',
      }),
      upload: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.profilePicture.upload',
        defaultMessage: 'Click to upload profile picture',
      }),
      uploading: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.profilePicture.uploading',
        defaultMessage: 'Please wait while the picture is being processed',
      }),
      edit: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.profilePicture.edit',
        defaultMessage: 'Click to edit profile picture',
      }),
      sample: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.profilePicture.sample',
        defaultMessage: 'Sample suggestions for good profile pictures. Your profile picture should have the following attributes. A face/frame ratio of around 50%, clear picture with correct background and foreground illumination, an appropriate face to body ratio and with camera eye contact and smile',
      }),
      profile_pic: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.profilePicture.profilePic',
        defaultMessage: 'Your profile picture',
      }),
      zoom: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.profilePicture.zoom',
        defaultMessage: 'Zoom in and out with arrow keys',
      }),
      left_rotate: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.profilePicture.leftRotate',
        defaultMessage: 'Click to Rotate image 90 degree anti clockwise',
      }),
      right_rotate: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.profilePicture.rightRotate',
        defaultMessage: 'Click to Rotate image 90 degree clockwise',
      }),
      close_upload: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.profilePicture.closeUpload',
        defaultMessage: 'Click to close the upload profile picture modal',
      }),
      input_file: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.profilePicture.inputFile',
        defaultMessage: 'input type file. Only images formats',
      }),
    },
    personal_info: {
      suggested_url: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.personalInfo.suggestedUrl',
        defaultMessage: 'we have some url for you which you can use to increase your profile visibility',
      }),
      availability: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.personalInfo.availability',
        defaultMessage: 'Check availability of URLs on LinkedIn',
      }),
      name: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.personalInfo.name',
        defaultMessage: 'Edit or change your profile name',
      }),
      url: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.personalInfo.url',
        defaultMessage: 'Edit your LinkedIn url to increase profile visibility',
      }),
      enter_url: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.personalInfo.enterUrl',
        defaultMessage: 'Enter profile URL. Mandatory field',
      }),
      enter_name: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.personalInfo.enterName',
        defaultMessage: 'Enter name. Mandatory field',
      }),
    },
    Headline: {
      skill_try: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.Headline.skillTry',
        defaultMessage: 'Try to include 3-5 relevant skills to improve score',
      }),
      suggestion_edit: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.Headline.suggestionEdit',
        defaultMessage: 'Below are some suggestion for good headline',
      }),
      headline: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.Headline.headline',
        defaultMessage: 'headline suggestions basis your profile',
      }),
      category: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.Headline.category',
        defaultMessage: 'Similar users are writing about these categories',
      }),
      skill: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.Headline.skill',
        defaultMessage: 'Similar users are writing about these skills',
      }),

    },
    summary: {},
    experience: {},
    education: {},
    Summary: {
      mentioned_skill: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.summary.mentionedSkill',
        defaultMessage: 'you have mentioned these skills in your about',
      }),
      mentioned_skill_resume: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.summary.mentionedSkillResume',
        defaultMessage: 'you have mentioned these skills in your {resumeType, select, cv {CV} other {Resume}}',
      }, { resumeType: isResumeCalledCv ? 'cv' : 'resume' }),
      skill_try: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.summary.skillTry',
        defaultMessage: 'Try to include 10+ relevant skills to improve score',
      }),
      content_try: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.summary.contentTry',
        defaultMessage: 'Try to include 5-8 relevant categories in this section',
      }),
      mentioned_category: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.summary.mentionedCategory',
        defaultMessage: 'you have mentioned these categories in your About',
      }),
      include_category: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.summary.includeCategory',
        defaultMessage: 'Similar users are writing about these categories',
      }),
      tense: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.tense.correctWay',
          defaultMessage:
            'correct way As Product Manager at Google, I was responsible for developing product roadmap and introducing new product feature in collaboration with international cross-functional team. I was selected from amongst 200 employees to form 10 person strategic review team responsible for software product development, driving new product sales as well as managing relations with existing product users',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.tense.incorrectWay',
          defaultMessage:
            'incorrect way As Product Manager at Google, I was responsible for developing product roadmap and introducing new product feature in collaboration with international cross-functional team. I am selected from amongst 200 employees to form 10 person strategic review team responsible for software product development, driving new product sales as well as managing relations with existing product users',
        }),
      },
      narrative_voice: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.narrativeVoice.correctWay',
          defaultMessage:
            'correct way I am a Management Consultant with 8 years of experience serving telecommunications and technology clients. I am presently working at KPMG and have proven expertise in financial and data analysis.',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.narrativeVoice.incorrectWay',
          defaultMessage:
            'incorrect way Management Consultant with 8 years experience serving telecommunications and technology clients. I am working at KPMG and have gained expertise in financial analysis and data analysis.',
        }),
      },
      specifics: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.specifics.correctWay',
          defaultMessage:
            'correct way Developed product roadmap and introduced new product features in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15%',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.specifics.incorrectWay',
          defaultMessage:
            'incorrect way Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth',
        }),
      },
      action_oriented: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.actionOriented.correctWay',
          defaultMessage:
            'correct way Developed product roadmap and introduced new product features in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15%',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.actionOriented.incorrectWay',
          defaultMessage:
            'incorrect way Responsible for developing product roadmap and introducing new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15%',
        }),
      },
      verb_overusage: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.verbOverusage.correctWay',
          defaultMessage:
            'correct way I developed product roadmap in collaboration with international cross-functional team, generating ideas to redesign product promotion strategies. I also established and trained 10 person strategic review team responsible for product development.',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.verbOverusage.incorrectWay',
          defaultMessage:
            'incorrect way I developed product roadmap in collaboration with international cross-functional team, generating ideas to redesign product promotion strategies. I also developed and trained 10 person strategic review team responsible for product development.',
        }),
      },
      buzzwords: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.buzzwords.correctWay',
          defaultMessage:
            'correct way I am a committed and competent professional with expertise in Financial Analysis and Valuation',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.summary.buzzwords.incorrectWay',
          defaultMessage:
            'incorrect way I am a dedicated individual and am an expert in Financial Analysis and Valuation',
        }),
      },
    },
    Experience: {
      input_title: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.inputTitle',
        defaultMessage: 'Enter Job title, mandatory field.',
      }),
      input_company: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.inputCompany',
        defaultMessage: 'Enter Company name, mandatory field.',
      }),
      is_current: {
        true: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.isCurrent',
          defaultMessage: 'Check if this is current experience. Press space to check or uncheck',
        }),
        false: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.isCurrent',
          defaultMessage: 'Check if this is current experience. Press space to check or uncheck',
        }),
      },
      to: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.to',
        defaultMessage: 'Select end month and year from the following drop down, tab to move to drop down. Mandatory field',
      }),
      from: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.from',
        defaultMessage: 'Select start month and year from the following drop down, tab to move to drop down. Mandatory field',
      }),
      from_month: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.fromMonth',
        defaultMessage: 'Select start month from drop down by arrow key, Mandatory field',
      }),
      from_year: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.fromYear',
        defaultMessage: 'Select start year from drop down by arrow key, Mandatory field',
      }),
      to_month: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.toMonth',
        defaultMessage: 'Select end month from drop down by arrow key, Mandatory field',
      }),
      to_year: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.toYear',
        defaultMessage: 'Select end year from drop down by arrow key, Mandatory field',
      }),
      mentioned_skill: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.mentionedSkill',
        defaultMessage: 'you have mentioned these skills in your Experience',
      }),
      mentioned_skill_resume: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.mentionedSkillResume',
        defaultMessage: 'you have mentioned these skills in your {resumeType, select, cv {CV} other {Resume}}',
      }, { resumeType: isResumeCalledCv ? 'cv' : 'resume' }),
      no_skill: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.noSkill',
        defaultMessage: 'You have not mentioned skills effectively. Please refer to the following guidance for specialised tips on how to highlight skills in this section.',
      }),
      skill_try: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.skillTry',
        defaultMessage: 'Try to include 8+ relevant skills to improve score',
      }),
      content_try: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.contentTry',
        defaultMessage: 'Try to include 2-4 relevant categories in this section',
      }),
      mentioned_category: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.mentionedCategory',
        defaultMessage: 'you have mentioned these categories in your Experience',
      }),
      include_category: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.experience.includeCategory',
        defaultMessage: 'Similar users are writing about these categories',
      }),
      tense: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.tense.correctWay',
          defaultMessage:
            'correct way Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15% Selected from amongst 200 employees to form 10 person strategic review team responsible for software product development; spearheaded new product sales and managed relations with existing product users',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.tense.incorrectWay',
          defaultMessage:
            'incorrect way Develop product roadmap and introducing new product feature in collaboration with international cross-functional team; generate ideas to redesign product promotion strategies, leading to revenue growth of 15% Selected from amongst 200 employees to form 10 person strategic review team responsible for software product development, driving new product sales as well as managing relations with existing product users',
        }),
      },
      narrative_voice: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.narrativeVoice.correctWay',
          defaultMessage:
            'correct way Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15%',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.narrativeVoice.incorrectWay',
          defaultMessage:
            'incorrect way Responsible for developing product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15%',
        }),
      },
      specifics: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.specifics.correctWay',
          defaultMessage:
            'correct way Developed product roadmap and introduced new product features in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15%',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.specifics.incorrectWay',
          defaultMessage:
            'incorrect way Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth',
        }),
      },
      action_oriented: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.actionOriented.correctWay',
          defaultMessage:
            'correct way Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15%',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.actionOriented.incorrectWay',
          defaultMessage:
            'incorrect way Responsible for developing product roadmap and introducing new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15%',
        }),
      },
      verb_overusage: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.verbOverusage.correctWay',
          defaultMessage:
            'correct way Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15% Selected from amongst 200 employees to form 10 person strategic review team responsible for software product development; drove new product sales and managed relations with existing product users',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.verbOverusage.incorrectWay',
          defaultMessage:
            'incorrect way Analysed past marketing data and prepared digital marketing strategies; implemented strategies to drive 25% increase in new customers Compared and analysed results from campaign and took corrective actions; provided sales data and marketing training material to new analysts, improving efficiency by 28%',
        }),
      },
      buzzwords: {
        correct_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.buzzwords.correctWay',
          defaultMessage:
            'correct way Developed product roadmap in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15%',
        }),
        incorrect_way: intl.formatMessage({
          id: 'aspire.editModalAriaLabel.experience.buzzwords.incorrectWay',
          defaultMessage:
            'incorrect way Developed the product roadmap in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies that led to revenue growth of 15%',
        }),
      },
    },
    Education: {
      skill_try: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.skillTry',
        defaultMessage: 'Try to include 2-4 relevant skills to improve score',
      }),
      mentioned_skill: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.mentionedSkill',
        defaultMessage: 'you have mentioned these skills in your education',
      }),
      mentioned_skill_resume: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.mentionedSkillResume',
        defaultMessage: 'you have mentioned these skills in your {resumeType, select, cv {CV} other {Resume}}',
      }, { resumeType: isResumeCalledCv ? 'cv' : 'resume' }),
      no_skill: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.noSkill',
        defaultMessage: 'You have not mentioned skills effectively. Please refer to the following guidance for specialised tips on how to highlight skills in this section.',
      }),
      content_try: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.contentTry',
        defaultMessage: 'Try to include 5-8 relevant categories in this section',
      }),
      mentioned_category: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.mentionedCategory',
        defaultMessage: 'you have mentioned these categories in your education',
      }),
      include_category: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.includeCategory',
        defaultMessage: 'Similar users are writing about these categories',
      }),
      input_school: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.inputSchool',
        defaultMessage: 'Enter School name, mandatory field.',
      }),
      input_degree: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.inputDegree',
        defaultMessage: 'Enter Degree name. ',
      }),
      input_field: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.inputField',
        defaultMessage: 'Enter field of study. ',
      }),
      from_year: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.fromYear',
        defaultMessage: 'Select start year from drop down by arrow key, Mandatory field',
      }),
      to_year: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.toYear',
        defaultMessage: 'Select end year from drop down by arrow key, Mandatory field',
      }),
      to: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.to',
        defaultMessage: 'Select end month and year from the following drop down, tab to move to drop down. Mandatory field. ',
      }),
      from: intl.formatMessage({
        id: 'aspire.editModalAriaLabel.education.from',
        defaultMessage: 'Select start month and year from the following drop down, tab to move to drop down. Mandatory field',
      }),
    },
  }
}


export function infoScreenConnectLabel(intl) {
  return {
    language: intl.formatMessage({
      id: 'aspire.infoScreenConnectLabel.language',
      defaultMessage: 'Click to know more about language',
    }),
    seo: intl.formatMessage({
      id: 'aspire.infoScreenConnectLabel.seo',
      defaultMessage: 'Click to know more about Search engine optimisation keywords',
    }),
    skills: intl.formatMessage({
      id: 'aspire.infoScreenConnectLabel.skills',
      defaultMessage: 'Click to know more about skills',
    }),
    impact: intl.formatMessage({
      id: 'aspire.infoScreenConnectLabel.impact',
      defaultMessage: 'Click to know more about impactful sentences',
    }),
    information_category: intl.formatMessage({
      id: 'aspire.infoScreenConnectLabel.informationCategory',
      defaultMessage: 'Click to know more about information category',
    }),
    profile_picture: intl.formatMessage({
      id: 'aspire.infoScreenConnectLabel.profilePicture',
      defaultMessage: 'Click to know more about good profile picture',
    }),
  }
}


export function infoScreenAriaLabel(intl, isUKEnable = false) {
  return {
    close: intl.formatMessage({
      id: 'aspire.infoScreenAriaLabel.close',
      defaultMessage: 'Click to close the information modal',
    }),
    next: intl.formatMessage({
      id: 'aspire.infoScreenAriaLabel.next',
      defaultMessage: 'Click to see next sample',
    }),
    previous: intl.formatMessage({
      id: 'aspire.infoScreenAriaLabel.previous',
      defaultMessage: 'click to see previous sample',
    }),
    category: {
      what: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.category.what',
        defaultMessage: 'What are Information Categories?',
      }),
      text: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.category.text',
        defaultMessage:
          'Your profile needs to include certain important pieces of information that gives your profile visitors an overall view of you as a professional for example, your job role, job functions, educational qualification etc. This information helps recruiters figure out if you might be the correct fit for their company',
      }),
      list: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.category.list',
        defaultMessage: 'List of categories that you can include',
      }),
      next: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.category.next',
        defaultMessage: 'click to know next sample then shift tab to listen',
      }),
      previous: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.category.previous',
        defaultMessage: 'click to know previous sample then shift tab to listen',
      }),
      heading: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.category.heading',
        defaultMessage:
          'Illustrations of how Information Categories improve first impression',
      }),
      Headline: {
        sample: {
          first: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Headline.sample.first',
            defaultMessage:
              'This example include Job Function,Industry, Job Role, Company/Organisation. Begin with 5 yrs experience in Marketing as job function in Technology Industry as industry. Product Manager as job role at Apple as company, skilled in Product marketing as job function',
          }),
          second: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Headline.sample.second',
            defaultMessage:
              'This example include Degree, Concentration,   School/University, Goal Based Keyword, Job Function. Begin with MBA Finance & Strategy as degree concentration, Candidate at Stanford as university, Looking or interested as goal based keyword for internship opportunities in the field of Business Development as job function.',
          }),
          third: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Headline.sample.third',
            defaultMessage:
              'This example include Goal Based Keyword,Job Function,Position of Responsibility,Club/Society, Certifications. Begin with Recent graduate seeking or looking as goal based keyword Investment Banking as job function internship | President - Finance Club as position of responsibility and club | CFA as certificate, Asset Management, Strategy as job function',
          }),
        },
      },
      Summary: {
        sample: {
          first: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Summary.sample.first',
            defaultMessage:
              'With 8 years of experience in job role at company name, for example Human Resources Manager at Goldman Sachs including 2 years of experience your job function, for example, talent development and recruiting, I have recently obtained a certificatio, for example, Professional Certificate in Human Resources, and am aiming to open my own HR Consultancy for providing HR solutions to a diverse and wide set of companies.',
          }),
          second: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Summary.sample.second',
            defaultMessage:
              'At College, I was the Chairman, or any position of responsibility of the clubs and society for example, Toastmasters Club. As Chairman, I organized various training sessions and workshops for students. I had also participated in various competition and received awards, for example international competitions and had won the 1st prize in the KPMG International Case Competition twice in a row',
          }),
          third: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Summary.sample.third',
            defaultMessage:
              'start with including degree and concentration from your university then summarise, for example, I am an MBA as degree candidate, focusing on Finance as concentration and Strategy as concentration at Harvard Business School as university and have prior experience of 3 years in the same field. I have always been academically inclined and graduated Summa Cum Laude from Cornell University as university.',
          }),
          fourth: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Summary.sample.fourth',
            defaultMessage:
              'start with a goal based keyword towards your industry, for example I am presently looking for opportunities in the Education Industry as I always felt that working for student development and enhancing students’ careers was my calling in life. I can be reached at contact information for example abc.jkl@gmail.com.',
          }),
        },
      },
      Experience: {
        sample: {
          first: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Experience.sample.first',
            defaultMessage:
              'This example includes Job Role, Job Function , Company/Organisation, Industry. Headline as Accounting Intern as job role - Accounts payable as job function | Accounts receivables | Auditing at Deloitte as company. Include your duration of experience. Then summarise. As part of summer internship at Deloitte as company , I undertook the following task:- Performed meticulous accounting as job function for companies across Healthcare and Technology industries as industry. processed and consolidated 100+ customer and vendor invoices, saving company close to $10,000 in interest payments',
          }),
          second: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Experience.sample.second',
            defaultMessage:
              'This example includes Position of Responsibility, Club/Society, School/University, Awards, Competitions, Goal Based Keyword. Headline as President - Marketing Club as position of responsibility at Harvard Business School as university. Include your duration of experience. While pursuing my MBA, I was President of Marketing Club and had won "Student of the Year D Award" as awards as well as various international competitions as competition. I was majorly responsible for:- Organising 10+ competitions and seminars every year, looking for and inviting industry professionals as goal based keyword to speak at events and getting maximum student turnout',
          }),
          third: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Experience.sample.third',
            defaultMessage:
              'This example include Degree, Concentration, School/University and Certifications. Headline as MBA Finance as degree concentration Student at C Harvard Business School as university. Include your duration of experience. Then summarise. Presently, I am pursuing MBA in Finance and Strategy at Harvard Business School, graduating in 2017. Over the last 1 year, I have built skills in financial analysis and modeling, along with investment analysis and investment strategies.- Received CFA Certification as certifications 2 months earlier; tutored batch of 100+ students in basic financial management concepts securing top of class results',
          }),
        },
      },
      Education: {
        sample: {
          first: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Education.sample.first',
            defaultMessage:
              'This example includes information categories School/University, Degree, Concentration, Position of Responsibility, Club/Society, Certifications. Headline as London Business School as school Master of Business Administration (MBA), Finance as Degree, concentration. Include duration of education for example 2015 - 2017. Include your major achievements for example Activities and Societies: President as position of responsibilty, Consulting Club, Member - Energy Club , Member - Business Club and China Club as clubs and society, completed CFA Certification as certification',
          }),
          second: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.category.Education.sample.second',
            defaultMessage:
              'This example includes School/University, Degree, Concentration, Club/Society,   Awards, Competitions. Headline as Harvard Business School as school, Master of Business Administration (MBA), Finance as degree, concentraion. Include duration of education for example 2015 - 2017. Include your major achievements for example Activities and Societies: Member of Private Equity and Venture Capital Club as clubs, Winner as awards of Case Study Competition as competition',
          }),
        },
      },
    },
    impact: {
      what: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.impact.what',
        defaultMessage: 'what is impact?',
      }),
      text: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.impact.text',
        defaultMessage: `Impact refers to the effect of your profile on visitors. It can be measured by the way you have conveyed your actions and their outcomes in your profile. If after reading a sentence, the recruiter immediately notices your action and its effect, you have done a good job in reflecting the impact of your experiences.`,
      }),
      action_oriented: {
        Summary: {
          text: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.impact.actionOriented.Summary.text',
            defaultMessage: `If you are including bullets in your summary section, begin with
            strong action verbs that inform the Recruiter of the exact actions
            YOU performed.`,
          }),
          correct: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.impact.actionOriented.Summary.correct',
            defaultMessage: `correct bullet example is, 
            Developed product roadmap
            and introduced new product features in collaboration with
            international cross-functional team; generated ideas to redesign
            product promotion strategies, leading to revenue growth of 15%
          `,
          }),
          incorrect: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.impact.actionOriented.Summary.incorrect',
            defaultMessage: `
        incorrect bullet example is, 
            Responsible for developing
            product roadmap and introducing new product feature in collaboration
            with international cross-functional team; generated ideas to
            redesign product promotion strategies, leading to revenue growth of
            15%
          `,
          }),
        },
        Experience: {
          text: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.impact.actionOriented.Experience.text',
            defaultMessage: `
            Your experience needs to showcase the work YOU did. Begin your
            sentences with strong action verbs that inform the Recruiter of the
            exact actions YOU performed.
          `,
          }),
          correct: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.impact.actionOriented.Experience.correct',
            defaultMessage: `correct bullet example is,
            Developed product roadmap
            and introduced new product feature in collaboration with
            international cross-functional team; generated ideas to redesign
            product promotion strategies, leading to revenue growth of 15%
          `,
          }),
          incorrect: intl.formatMessage({
            id: 'aspire.infoScreenAriaLabel.impact.actionOriented.Experience.incorrect',
            defaultMessage: `incorrect bullet example is,
            Responsible for developing
            product roadmap and introducing new product feature in collaboration
            with international cross-functional team; generated ideas to
            redesign product promotion strategies, leading to revenue growth of
            15%
          `,
          }),
        },
      },
      specifics: {
        text: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.impact.specifics.text',
          defaultMessage: `
          Specifics refer to the quantification of outcomes/ impact in your
          profile. These are outlined by a quantifiable outcome or size and
          scope of work. Examples include revenue, cost, size of your team, or
          departments you supported.
        `,
        }),
        correct: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.impact.specifics.correct',
          defaultMessage: `correct bullet example is, 
            Developed product roadmap
            and introduced new product features in collaboration with
            international cross-functional team; generated ideas to redesign
            product promotion strategies, leading to revenue growth of 15%
          `,
        }),
        incorrect: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.impact.specifics.incorrect',
          defaultMessage: `incorrect bullet example is, 
            Developed product roadmap
            and introduced new product feature in collaboration with
            international cross-functional team; generated ideas to redesign
            product promotion strategies, leading to revenue growth
          `,
        }),
      },
    },
    language: {
      what: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.language.what',
        defaultMessage: 'What is the role of language in LinkedIn profile?',
      }),
      text: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.language.text',
        defaultMessage:
          'Your language plays a huge role in guiding the recruiter’s decision to continue reading your profile or not. Make sure that you avoid basic grammatical mistakes, write in consistent tense and avoid overuse of words.',
      }),
      sectionData: {
        voice: {
          Summary: {
            text: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.voice.Summary.text',
              defaultMessage: `Voice consistency is a measure to check the amount of switch between voices in your about section. Make sure that you are not switching from first person to third person or vice versa when talking about yourself.`,
            }),
            correct: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.voice.Summary.correct',
              defaultMessage: `correct bullet example is, I am a Management Consultant with 8 years of experience serving telecommunications and technology clients. I am presently working at KPMG and have proven expertise in financial and data analysis.`,
            }),
            incorrect: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.voice.Summary.incorrect',
              defaultMessage: `incorrect bullet example is, Management Consultant with 8 years experience serving telecommunications and technology clients. I am working at KPMG and have gained expertise in financial analysis and data analysis.`,
            }),
          },
          Experience: {
            text: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.voice.Experience.text',
              defaultMessage: `The system identifies and evaluates narrative voice. It is advisable to write in first person instead of third person when talking about yourself as it creates a direct connect with recruiters or people visiting your profile.`,
            }),
            correct: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.voice.Experience.correct',
              defaultMessage: `correct bullet example is, Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15%`,
            }),
            incorrect: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.voice.Experience.incorrect',
              defaultMessage: `incorrect bullet example is, Responsible for developing product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15%`,
            }),
          },
        },
        tenseconsistency: {
          Summary: {
            text: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.tenseconsistency.Summary.text',
              defaultMessage: `Tense consistency is a measure to check the amount of switch between tenses in your about section. To avoid presenting a disconcerting read to the reviewer and to ensure consistency, one should write the summary without switching between tenses too much.`,
            }),
            correct: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.tenseconsistency.Summary.correct',
              defaultMessage: `correct bullet example is, As Product Manager at Google, I was responsible for developing product roadmap and introducing new product feature in collaboration with international cross-functional team. I was selected from amongst 200 employees to form 10 person strategic review team responsible for software product development, driving new product sales as well as managing relations with existing product users`,
            }),
            incorrect: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.tenseconsistency.Summary.incorrect',
              defaultMessage: `incorrect bullet example is, As Product Manager at Google, I was responsible for developing product roadmap and introducing new product feature in collaboration with international cross-functional team. I am selected from amongst 200 employees to form 10 person strategic review team responsible for software product development, driving new product sales as well as managing relations with existing product users`,
            }),
          },
          Experience: {
            text: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.tenseconsistency.Experience.text',
              defaultMessage: `Tense consistency is a measure to check the amount of switch between tenses in your experience section. To avoid presenting a disconcerting read to the reviewer and to ensure consistency, one should write the experience without switching between tenses.`,
            }),
            correct: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.tenseconsistency.Experience.correct',
              defaultMessage: `correct bullet example is, Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to revenue growth of 15% next bullet point Selected from amongst 200 employees to form 10 person strategic review team responsible for software product development; spearheaded new product sales and managed relations with existing product users`,
            }),
            incorrect: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.tenseconsistency.Experience.incorrect',
              defaultMessage: `incorrect bullet example is, Develop product roadmap and introducing new product feature in collaboration with international cross-functional team; generate ideas to redesign product promotion strategies, leading to revenue growth of 15%                              
                               next bullet point
                 Selected from amongst 200 employees to form 10 person strategic review team responsible for software product development, driving new product sales as well as managing relations with existing product users`,
            }),
          },
        },
        avoidedwords: {
          Summary: {
            text: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.avoidedwords.Summary.text',
              defaultMessage: `
                Avoided Words include passive language, filler words, often used
                in a sentence such as 'successfully', 'the', 'which', 'where',
                and others that consume valuable space on your profile without
                creating much impact.
                It may make sense to use these in some cases, so use your
                judgement to remove them completely or revise the sentence
                content, making it more concise and impactful.
          `,
            }),
            correct: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.avoidedwords.Summary.correct',
              defaultMessage: `correct bullet example is, 
                I am a committed and competent professional with expertise in
                Financial Analysis and Valuation
          `,
            }),
            incorrect: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.avoidedwords.Summary.incorrect',
              defaultMessage: `incorrect bullet example is, 
                I am a dedicated
                 individual
                and am an expert in Financial Analysis and Valuation
          `,
            }),
          },
          Experience: {
            text: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.avoidedwords.Experience.text',
              defaultMessage: `
                Avoided Words include passive language, filler words, often used
                in a sentence such as 'successfully', 'the', 'which', 'where',
                and others that consume valuable space on your profile without
                creating much impact.
                It may make sense to use these in some cases, so use your
                judgement to remove them completely or revise the sentence
                content, making it more concise and impactful.
          `,
            }),
            correct: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.avoidedwords.Experience.correct',
              defaultMessage: `correct bullet example is, 
                  Developed product
                roadmap in collaboration with international cross-functional
                team; generated ideas to redesign product promotion strategies,
                leading to revenue growth of 15%
          `,
            }),
            incorrect: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.avoidedwords.Experience.incorrect',
              defaultMessage: `incorrect bullet example is, 
                  Developed
                 the
                 product roadmap in
                collaboration with international cross-functional team;
                generated ideas to redesign product promotion strategies
                 that
                 led to revenue growth of
                15%
          `,
            }),
          },
        },
        verboverusage: {
          Summary: {
            text: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.verboverusage.Summary.text',
              defaultMessage: `
              Using same words again and again makes a profile sound too
              repetitive, diminishing the chances of important information
              standing out. Each word of the profile holds a certain weight and
              repeating words lends a negative impression.
          `,
            }),
            correct: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.verboverusage.Summary.correct',
              defaultMessage: `correct bullet example is, 
                I developed product roadmap in collaboration with international
                cross-functional team, generating ideas to redesign product
                promotion strategies. I also established and trained 10 person
                strategic review team responsible for product development.
          `,
            }),
            incorrect: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.verboverusage.Summary.incorrect',
              defaultMessage: `incorrect bullet example is, 
                I developed
                 product roadmap in
                collaboration with international cross-functional team,
                generating ideas to redesign product promotion strategies. I
                also developed
                 and trained 10
                person strategic review team responsible for product
                development.
          `,
            }),
          },
          Experience: {
            text: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.verboverusage.Experience.text',
              defaultMessage: `
              Using same words again and again makes a profile sound too
              repetitive, diminishing the chances of important information
              standing out. Each word of the profile holds a certain weight and
              repeating words lends a negative impression.
          `,
            }),
            correct: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.verboverusage.Experience.correct',
              defaultMessage: `correct bullet example is, 
                  Developed product
                roadmap and introduced new product feature in collaboration with
                international cross-functional team; generated ideas to redesign
                product promotion strategies, leading to revenue growth of 15%
              next bullet point
                  Selected from amongst
                200 employees to form 10 person strategic review team
                responsible for software product development; drove new product
                sales and managed relations with existing product users
          `,
            }),
            incorrect: intl.formatMessage({
              id: 'aspire.infoScreenAriaLabel.language.sectionData.verboverusage.Experience.incorrect',
              defaultMessage: `incorrect bullet example is, 
                Analysed
                 past marketing data
                and prepared digital marketing strategies; implemented
                strategies to drive 25% increase in new customers
                next bullet point
                  Compared and
                analysed
                 results from campaign
                and took corrective actions; provided sales data and marketing
                training material to new analysts, improving efficiency by 28%
          `,
            }),
          },
        },
      },
    },
    profile_picture: {
      what: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.profilePicture.what',
        defaultMessage: 'What factors to consider for perfect profile picture?',
      }),
      text: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.profilePicture.text',
        defaultMessage:
          'According to LinkedIn research, having a picture, by itself, makes your profile 14 times more likely to be viewed. It is your chance to have a good first impression on the Recruiter. Make sure that your picture is professional and has all the characteristics of a good image listed below.',
      }),
      sample: {
        face_frame: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.profilePicture.sample.faceFrame',
          defaultMessage: 'A good image has a face/frame ratio of around 50%.',
        }),
        face_body: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.profilePicture.sample.faceBody',
          defaultMessage:
            'In a good LinkedIn profile picture, your face covers a larger area as compared to your body.',
        }),
        background: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.profilePicture.sample.background',
          defaultMessage:
            'A good image has a light-{isUKEnable, select, true {coloured} other {colored}} background that helps to portray your picture clearly.',
        }, { isUKEnable: isUKEnable ? 'true' : 'false' }),
        foreground: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.profilePicture.sample.foreground',
          defaultMessage:
            'Ensure that shadows and other reflections do not interfere with the clarity and prominence of your face.',
        }),
        eye: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.profilePicture.sample.eye',
          defaultMessage:
            'One should make an eye contact with the camera. This portrays confidence in the person.',
        }),
        smile: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.profilePicture.sample.smile',
          defaultMessage:
            'An open smile increases likeability and is a feature in almost all good LinkedIn profile pictures.',
        }),
        size: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.profilePicture.sample.size',
          defaultMessage:
            'Photo size should be between 400 x 400 and 20K x 20K pixels for optimum picture clarity.',
        }),
      },
    },
    profile_strength: {
      what: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.profileStrength.what',
        defaultMessage: '',
      }),
      text: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.profileStrength.text',
        defaultMessage: '',
      }),
    },
    visibility: {
      what: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.visibility.what',
        defaultMessage: 'what is profile visibility?',
      }),
      text: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.visibility.text',
        defaultMessage:
          'Profile visibility refers to how early your profile features in a list of profiles when recruiters search by some keywords. Including keywords relevant to your target job function(s) in your profile helps improve your SEO ranking and increases the chances of recruiters finding your profile earlier.',
      }),
      sample: {
        text: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.visibility.sample.text',
          defaultMessage: 'Elements that help make a LinkedIn profile more visible:',
        }),
        keyword: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.visibility.sample.keyword',
          defaultMessage:
            'Using standard terminologies for job roles, competencies, skills, and any other jargon helps your profile match search queries that recruiters use.',
        }),
        skill: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.visibility.sample.skill',
          defaultMessage:
            'Include as many skills relevant to target function(s) as possible in your profile so that when the recruiter searches with any skill relevant to your target function(s), your profile prominently features at the top of the list.',
        }),
        category: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.visibility.sample.category',
          defaultMessage:
            'Mentioning job roles, job functions, schools, companies, all help in directing your profile towards searches that recruiters would be doing.',
        }),
      },
    },
    skill: {
      what: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.skill.what',
        defaultMessage: 'How and why are skills important for your LinkedIn Profile?',
      }),
      text: intl.formatMessage({
        id: 'aspire.infoScreenAriaLabel.skill.text',
        defaultMessage:
          'Relevant skills refer to skills that are important for pursuing a career in your chosen target function(s). Including these skills in your profile makes the recruiters feel that you are a better fit for the job and increases your chances of being singled out for that job. Follow the diagram below to decide which skills to focus on.',
      }),
      sample: {
        focus: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.focus',
          defaultMessage: 'What skills to focus on?',
        }),
        focus_ans: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.focusAns',
          defaultMessage:
            'With our machine learning and AI engines, you can exactly know what skills are valued for the target functions you have selected. Try to focus on the intersection of what you have and what is required.',
        }),
        write: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.write',
          defaultMessage: 'How to write about skills?',
        }),
        write_ans: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.writeAns',
          defaultMessage:
            'Writing about skills can be done in two ways, they can be stated directly or as phrases from which the reader can derive skills. For higher visibility, try using direct forms of skills so that recruiters can easily find you.',
        }),
        stated: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.stated',
          defaultMessage: 'know what are stated skills',
        }),
        stated_ans: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.statedAns',
          defaultMessage:
            'Stated skills are skills that are mentioned directly in your profile. Stating a relevant skill increases your SEO ranking.',
        }),
        stated_ex_1: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.statedEx1',
          defaultMessage:
            'example To showcase “Business Development” skill, you can write: Led and improved business development efforts and reduced client acquisition cost by 38%',
        }),
        stated_ex_2: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.statedEx2',
          defaultMessage:
            'example To showcase “Recruiting” skill, you can write: Worked as HR Manager and handled recruiting of new and efficient candidates for KPMG; reduced vacancies, improving efficiency by 25%',
        }),
        derived: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.derived',
          defaultMessage: 'know what are derived skills',
        }),
        derived_ans: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.derivedAns',
          defaultMessage:
            'Derived skills are skills that have been mentioned in such a way that the reader can infer the skill from the language used',
        }),
        derived_ex_1: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.derivedEx1',
          defaultMessage:
            'example To showcase “Strategy Implementation” skill, you can write: Developed and executed Go to Market strategies, resulting in increased sales and profit',
        }),
        derived_ex_2: intl.formatMessage({
          id: 'aspire.infoScreenAriaLabel.skill.sample.derivedEx2',
          defaultMessage:
            'example To showcase “Team Leadership” skill, you can write: Led cross-functional team of Business Development, Marketing, HR and IT to design 2 CRM data-processing tools for optimum client handling',
        }),
      },
    },
  }
}




export function logModalAriaLabel(intl) {
  return {
    revert: intl.formatMessage({
      id: 'aspire.constants.logModalAriaLabel.revert',
      defaultMessage: 'Revert to this version',
    }),
    close: intl.formatMessage({
      id: 'aspire.constants.logModalAriaLabel.close',
      defaultMessage: 'Click to close the log modal',
    }),
    '1': intl.formatMessage({
      id: 'aspire.constants.logModalAriaLabel.scoreImproved',
      defaultMessage: 'score improved from this version',
    }),
    '-1': intl.formatMessage({
      id: 'aspire.constants.logModalAriaLabel.scoreDecreased',
      defaultMessage: 'score decreased from this version',
    }),
    '0': intl.formatMessage({
      id: 'aspire.constants.logModalAriaLabel.noImprovement',
      defaultMessage: 'No improvement from this version,',
    }),
  }
}

export function resumePDFChangeFunctionModalAriaLabel(intl, isResumeCalledCv = false) {
  return {
    close: intl.formatMessage({
      id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.close',
      defaultMessage: 'Click to close the modal',
    }),
    pdf: {
      upload: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.pdf.upload',
        defaultMessage:
          'click to upload the LinkedIn pdf, by uploading your pdf you will be able to unlock your full profile feedback. ',
      }),
      steps: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.pdf.steps',
        defaultMessage: `Below are the steps to upload your linkedin profile`,
      }),
      step1: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.pdf.step1',
        defaultMessage:
          'Click the ‘Go to LinkedIn’ button provided below to open your linkedin account. It will open in a new tab.',
      }),
      step2: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.pdf.step2',
        defaultMessage: `Click ‘More’ button on the linkedin page and then ‘Save to PDF’ from the dropdown`,
      }),
      step3: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.pdf.step3',
        defaultMessage: `Upload your downloaded pdf here`,
      }),
      go_to: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.pdf.goTo',
        defaultMessage: 'Click to go to your linkedin profile, new tab will be open',
      }),
      file_input: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.pdf.fileInput',
        defaultMessage: 'input type file. only pdf',
      }),
    },
    resume: {
      match: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.resume.match',
        defaultMessage:
          'We provide the skill match between your {resumeType, select, cv {CV} other {resume}} and LinkedIn to maintain consistency',
      }, { resumeType: isResumeCalledCv ? 'cv' : 'resume' }),
      upload: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.resume.upload',
        defaultMessage:
          'Click to upload a new {resumeType, select, cv {CV} other {resume}} in PDF format. {resumeType, select, cv {CV} other {Resume}} will be processed automatically once uploaded.',
      }, { resumeType: isResumeCalledCv ? 'cv' : 'resume' }),
      uploaded: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.resume.uploaded',
        defaultMessage:
          'You have the option to select the {resumeType, select, cv {CV} other {resume}} you have uploaded to our platform; you can select it from there',
      }, { resumeType: isResumeCalledCv ? 'cv' : 'resume' }),
      no_upload: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.resume.noUpload',
        defaultMessage: 'You have not uploaded any {resumeType, select, cv {CV} other {resume}} on our platform',
      }, { resumeType: isResumeCalledCv ? 'cv' : 'resume' }),
      note: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.resume.note',
        defaultMessage:
          'Please note, only {resumeType, select, cv {CVs} other {resume}} in PDF format are allowed and no cover letter',
      }, { resumeType: isResumeCalledCv ? 'cv' : 'resume' }),
      resume: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.resume.resume',
        defaultMessage: 'uploaded on {resumeType, select, cv {CV} other {resume}} platform, Click to check it out there',
      }, { resumeType: isResumeCalledCv ? 'cv' : 'resume' }),
      cf: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.resume.cf',
        defaultMessage: 'uploaded on career fit platform, click to check it out there',
      }),
      file_input: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.resume.fileInput',
        defaultMessage: 'input type file. only pdf',
      }),
    },
    cf: {
      feedback: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.cf.feedback',
        defaultMessage: 'Click to view feedback',
      }),
      select: intl.formatMessage({
        id: 'aspire.constants.resumePDFChangeFunctionModalAriaLabel.cf.select',
        defaultMessage: 'Please select atleast one or at max 3 Target functions',
      }),
    },
  }
}

export function zoneToAriaLabelMapping(intl) {
  return {
    picture_empty: intl.formatMessage({
      id: 'aspire.constants.zoneToAriaLabelMapping.pictureEmpty',
      defaultMessage:
        'You have not uploaded your profile picture! Upload profile picture in the edit mode.',
    }),
    empty: intl.formatMessage({
      id: 'aspire.constants.zoneToAriaLabelMapping.empty',
      defaultMessage:
        'You have not written this section!, start writing in the edit mode.',
    }),
    red: intl.formatMessage({
      id: 'aspire.constants.zoneToAriaLabelMapping.red',
      defaultMessage:
        'Needs Work, Consider the feedback to improve this section.',
    }),
    yellow: intl.formatMessage({
      id: 'aspire.constants.zoneToAriaLabelMapping.yellow',
      defaultMessage:
        'is on Track, Consider the feedback to improve this section.',
    }),
    green: intl.formatMessage({
      id: 'aspire.constants.zoneToAriaLabelMapping.green',
      defaultMessage:
        'Looks Good, You have done a good job with this section!',
    }),
  }
}

export function summaryScreenAriaLabel(intl) {
  return {
    see_how: intl.formatMessage({
      id: 'aspire.constants.summaryScreenAriaLabel.seeHow',
      defaultMessage:
        'Unlock the full feedback for all sections by uploading your full profile, click to upload your linkedin PDF',
    }),
    see_how_clicked: intl.formatMessage({
      id: 'aspire.constants.summaryScreenAriaLabel.seeHowClicked',
      defaultMessage: 'Your profile is being processed please wait',
    }),
  }
}

export function customerFeedbackAriaLabel(intl) {
  return {
    close: intl.formatMessage({
      id: 'aspire.constants.customerFeedbackAriaLabel.close',
      defaultMessage: 'click to close the feedback modal',
    }),
    later: intl.formatMessage({
      id: 'aspire.constants.customerFeedbackAriaLabel.later',
      defaultMessage: 'remind me later',
    }),
    submit: intl.formatMessage({
      id: 'aspire.constants.customerFeedbackAriaLabel.submit',
      defaultMessage: 'submit the feedback',
    }),
    feedbackLive: intl.formatMessage({
      id: 'aspire.constants.customerFeedbackAriaLabel.feedbackLive',
      defaultMessage: 'Please provide your valuable feedback.',
    }),
  }
}

export function dataIntegrationAriaLabel(intl) {
  return {
    close: intl.formatMessage({
      id: 'aspire.constants.dataIntegrationAriaLabel.close',
      defaultMessage: 'Click to close the data integration modal',
    }),
    copy: intl.formatMessage({
      id: 'aspire.constants.dataIntegrationAriaLabel.copy',
      defaultMessage:
        'Click this button to copy this section content to clipboard',
    }),
    download: intl.formatMessage({
      id: 'aspire.constants.dataIntegrationAriaLabel.download',
      defaultMessage:
        'Click to download the profile picture. You can directly upload this profile picture on your linkedIn profile',
    }),
    no_changes: intl.formatMessage({
      id: 'aspire.constants.dataIntegrationAriaLabel.noChanges',
      defaultMessage: 'You haven’t made any changes yet ',
    }),
    start_editing: intl.formatMessage({
      id: 'aspire.constants.dataIntegrationAriaLabel.startEditing',
      defaultMessage: 'Start editing to see improvements',
    }),
    copy_note: intl.formatMessage({
      id: 'aspire.constants.dataIntegrationAriaLabel.copyNote',
      defaultMessage: 'Note - Only description will be copied',
    }),
    go_to_linkedin: intl.formatMessage({
      id: 'aspire.constants.dataIntegrationAriaLabel.goToLinkedin',
      defaultMessage:
        'Click to go to your linkedin profile, this will open in a new tab',
    }),
  }
}
